import React from "react"
import { Carousel } from "react-bootstrap"
import { GatsbyImage } from "gatsby-plugin-image"

export default function Carouselcomp(carouselData) {
  const imagesArray = carouselData.imagesAll

  return (
    <div>
      <Carousel variant="dark" interval={null}>
        {imagesArray.map(carouselImage => (
          <Carousel.Item>
            <GatsbyImage image={carouselImage} alt="banner" />
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  )
}
